module.exports = __webpack_public_path__ + "media/images/new-ui-images/table-sort-up-8b657049fbb086838d9c92088ee857d8.svg";